// extracted by mini-css-extract-plugin
export var controlsContainer = "styles-module__controlsContainer___j0t0f";
export var dragHandle = "styles-module__dragHandle___NmjvZ";
export var listContainer = "styles-module__listContainer___F9_wr";
export var emptyContainer = "styles-module__emptyContainer___I2Fd8";
export var lists = "styles-module__lists___G6xe2";
export var removeIcon = "styles-module__removeIcon____U9ME";
export var container = "styles-module__container___RRiyf";
export var favoritesContainer = "styles-module__favoritesContainer___hT6W9";
export var titleAndContents = "styles-module__titleAndContents___S2TYP";
export var listTitle = "styles-module__listTitle___D_cgc";
export var listLink = "styles-module__listLink___yJ8jo";